// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalAlert_modal__gznuu","title":"ModalAlert_title__8krBI","description":"ModalAlert_description__VNacJ"};